import 'css-chunk:../node_modules/.pnpm/@revfluence+fresh@1.7.0_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/@revfluence/fresh/dist/aui.min.css';export default {
  "animation-duration-slow": ".3s",
  "animation-duration-base": ".2s",
  "animation-duration-fast": ".1s",
  "ease-base-out": "cubic-bezier(.7,.3,.1,1)",
  "ease-base-in": "cubic-bezier(.9,0,.3,.7)",
  "ease-out": "cubic-bezier(.215,.61,.355,1)",
  "ease-in": "cubic-bezier(.55,.055,.675,.19)",
  "ease-in-out": "cubic-bezier(.645,.045,.355,1)",
  "ease-out-back": "cubic-bezier(.12,.4,.29,1.46)",
  "ease-in-back": "cubic-bezier(.71,-.46,.88,.6)",
  "ease-in-out-back": "cubic-bezier(.71,-.46,.29,1.46)",
  "ease-out-circ": "cubic-bezier(.08,.82,.17,1)",
  "ease-in-circ": "cubic-bezier(.6,.04,.98,.34)",
  "ease-in-out-circ": "cubic-bezier(.78,.14,.15,.86)",
  "ease-out-quint": "cubic-bezier(.23,1,.32,1)",
  "ease-in-quint": "cubic-bezier(.755,.05,.855,.06)",
  "ease-in-out-quint": "cubic-bezier(.86,0,.07,1)",
  "btn-shadow": "none",
  "btn-primary-shadow": "none",
  "btn-text-shadow": "none",
  "btn-font-weight": "600",
  "screen-xs": "480px",
  "screen-sm": "576px",
  "screen-md": "768px",
  "screen-lg": "992px",
  "screen-xl": "1200px",
  "screen-xxl": "1600px",
  "spacing-xxxl": "80px",
  "spacing-xxl": "48px",
  "spacing-xl": "32px",
  "spacing-lg": "24px",
  "spacing-md": "16px",
  "spacing-sm": "12px",
  "spacing-xs": "8px",
  "spacing-xxs": "4px",
  "code-family": "SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace",
  "font-size-paragraph": "16px",
  "font-size-base": "14px",
  "font-size-xl": "20px",
  "font-size-lg": "16px",
  "font-size-sm": "12px",
  "font-weight-regular": "400",
  "font-weight-semibold": "600",
  "font-family": "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
  "border-radius-max": "9999px",
  "border-radius-lg": "12px",
  "border-radius-base": "6px",
  "border-radius-sm": "4px",
  "border-radius-xs": "2px",
  "height-lg": "40px",
  "height-base": "32px",
  "height-sm": "24px",
  "zindex-badge": "auto",
  "zindex-table-fixed": "2",
  "zindex-affix": "10",
  "zindex-back-top": "10",
  "zindex-picker-panel": "10",
  "zindex-popup-close": "10",
  "zindex-modal": "1000",
  "zindex-modal-mask": "1000",
  "zindex-message": "1010",
  "zindex-notification": "1010",
  "zindex-popover": "1030",
  "zindex-dropdown": "1050",
  "zindex-picker": "1050",
  "zindex-popoconfirm": "1060",
  "zindex-tooltip": "1070",
  "zindex-image": "1080",
  "primary": "#167cf4",
  "primary-40": "#3d73d7",
  "primary-10": "#e6f7ff",
  "secondary": "#f58984",
  "secondary-40": "#fcbbae",
  "secondary-10": "#fef0ed",
  "baygrey": "#989ea8",
  "grey-10": "#fafafa",
  "grey-25": "#e9e8ea",
  "grey-50": "#aeaeae",
  "grey-75": "#8f8f8f",
  "grey-100": "#1a1b1c",
  "white": "#fff",
  "black": "#1a1b1c",
  "green": "#006462",
  "sand": "#f6f3ef",
  "yellow": "#ffcd5b",
  "magenta-base": "#fdf",
  "red-base": "#f5b3b4",
  "volcano-base": "#ff9c93",
  "orange-base": "#fabf95",
  "gold-base": "#f1e5ac",
  "lime-base": "#ebffd0",
  "sage-base": "#c1e1c1",
  "cyan-base": "#c9f2f2",
  "blue-base": "#70d1f1",
  "geekblue-base": "#a2aff1",
  "purple-base": "#c5b3e3",
  "mauve-base": "#c6b0ca",
  "coral-base": "#ff8a8a",
  "apricot-base": "#f5a287",
  "marigold-base": "#fdaf1c",
  "butter-base": "#f9eda1",
  "apple-base": "#b7d275",
  "asparagus-base": "#9db17c",
  "tiffany-base": "#5fcdca",
  "baby-base": "#a3ddf9",
  "carolina-base": "#7eb3d8",
  "rose-base": "#ffb4c7",
  "watermelon-base": "#ffa1b6",
  "blue-0": "#f4fcff",
  "blue-1": "#e6f7ff",
  "blue-3": "#91d5ff",
  "blue-5": "#499dff",
  "blue-6": "#167cf4",
  "blue-7": "#2771c9",
  "gray-1": "#fff",
  "gray-2": "#fafafa",
  "gray-3": "#f5f5f5",
  "gray-4": "#f0f0f0",
  "gray-5": "#d9d9d9",
  "gray-6": "#bfbfbf",
  "gray-7": "#8c8c8c",
  "gray-8": "#505256",
  "gray-9": "#1f1f21",
  "red-1": "#fff1f0",
  "red-3": "#ffa39e",
  "red-4": "#ff7875",
  "red-5": "#ff4d4f",
  "red-6": "#f5222d",
  "gold-1": "#fffbe6",
  "gold-3": "#ffe58f",
  "gold-5": "#ffc53d",
  "gold-6": "#faad14",
  "gold-7": "#d48806",
  "green-1": "#f6ffed",
  "green-3": "#b7eb8f",
  "green-5": "#73d13d",
  "green-6": "#52c41a",
  "green-7": "#389e0d",
  "text-color": "#505256",
  "text-color-secondary": "#8c8c8c",
  "text-color-inverse": "#fff",
  "icon-color": "inherit",
  "icon-color-hover": "#1a1b1c",
  "heading-color": "#1f1f21",
  "text-color-dark": "#fff",
  "text-color-secondary-dark": "#fff",
  "text-selection-bg": "#167cf4",
  "link-color": "#167cf4",
  "modal-mask-bg": "rgba(79,90,114,.45)",
  "input-default-border-color": "#d9d9d9",
  "input-default-box-shadow": "#1890ff",
  "input-success-border-color": "#52c41a",
  "input-error-border-color": "#f5222d",
  "input-error-box-shadow": "#ff4d4f",
  "input-warning-border-color": "#faad14",
  "input-warning-box-shadow": "#faad14",
  "--gray-100": "#fff",
  "--gray-200": "#fafafa",
  "--gray-300": "#f5f5f5",
  "--gray-400": "#f0f0f0",
  "--gray-500": "#d9d9d9",
  "--gray-600": "#bfbfbf",
  "--gray-700": "#8c8c8c",
  "--gray-800": "#505256",
  "--gray-900": "#1f1f21",
  "--blue-100": "#f4fcff",
  "--blue-200": "#e6f7ff",
  "--blue-300": "#91d5ff",
  "--blue-500": "#499dff",
  "--blue-600": "#167cf4",
  "--blue-700": "#2771c9",
  "--red-100": "#fff1f0",
  "--red-300": "#ffa39e",
  "--red-400": "#ff7875",
  "--red-500": "#ff4d4f",
  "--red-600": "#f5222d",
  "--gold-100": "#fffbe6",
  "--gold-300": "#ffe58f",
  "--gold-500": "#ffc53d",
  "--gold-600": "#faad14",
  "--gold-700": "#d48806",
  "--green-100": "#f6ffed",
  "--green-300": "#b7eb8f",
  "--green-500": "#73d13d",
  "--green-600": "#52c41a",
  "--green-700": "#389e0d",
  "--magentabase": "#fdf",
  "--redbase": "#f5b3b4",
  "--volcanobase": "#ff9c93",
  "--orangebase": "#fabf95",
  "--goldbase": "#f1e5ac",
  "--limebase": "#ebffd0",
  "--sagebase": "#c1e1c1",
  "--cyanbase": "#c9f2f2",
  "--bluebase": "#70d1f1",
  "--geekbluebase": "#a2aff1",
  "--purplebase": "#c5b3e3",
  "--mauvebase": "#c6b0ca",
  "--coralbase": "#ff8a8a",
  "--apricotbase": "#f5a287",
  "--marigoldbase": "#fdaf1c",
  "--butterbase": "#f9eda1",
  "--applebase": "#b7d275",
  "--asparagusbase": "#9db17c",
  "--tiffanybase": "#5fcdca",
  "--babybase": "#a3ddf9",
  "--carolinabase": "#7eb3d8",
  "--rosebase": "#ffb4c7",
  "--watermelonbase": "#ffa1b6",
  "--breakpoints-xs": "480px",
  "--breakpoints-sm": "576px",
  "--breakpoints-md": "768px",
  "--breakpoints-lg": "992px",
  "--breakpoints-xl": "1200px",
  "--breakpoints-xxl": "1600px",
  "--spacing-xxxl": "80px",
  "--spacing-xxl": "48px",
  "--spacing-xl": "32px",
  "--spacing-lg": "24px",
  "--spacing-md": "16px",
  "--spacing-sm": "12px",
  "--spacing-xs": "8px",
  "--spacing-xxs": "4px",
  "--fontSize-xl": "20px",
  "--fontSize-lg": "16px",
  "--fontSize-base": "14px",
  "--fontSize-sm": "12px",
  "--fontWeight-regular": "400",
  "--fontWeight-semibold": "600",
  "--borderRadius-max": "9999px",
  "--borderRadius-base": "6px",
  "--borderRadius-sm": "4px",
  "--borderRadius-xs": "2px",
  "--height-lg": "40px",
  "--height-base": "32px",
  "--height-sm": "24px"
};